import { PunchOutApi, PunchOutIntegration } from '@idealsupply/ngclient-webservice-shopping-cart';

import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { map } from 'rxjs';
import { withCachedEntityStore } from 'state-data';

export interface PunchOutIntegrationsEntity {
  customerNumber: string;
  integrations: PunchOutIntegration[];
}

export const PunchOutIntegrationStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityStore({
    selectId: (p: PunchOutIntegrationsEntity) => p.customerNumber,
    load: (customerNumber: string) => {
      return inject(PunchOutApi)
        .getPunchOuts(customerNumber)
        .pipe(map((integrations) => ({ customerNumber, integrations })));
    },
    cacheSeconds: 60,
  }),
);
